import StripePaymentMethod, { StripeButton } from './components/StripePaymentMethods';

export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const bm = editor.BlockManager;
  const { labels, types, labelShoppingCartCategory } = opts;
  StripeButton(bm, labelShoppingCartCategory, labels.stripeButton, types.stripeButton);
  StripePaymentMethod(dc, labels.stripeButton, types.stripeButton, opts);
};
